// extracted by mini-css-extract-plugin
module.exports = {"quoteWrap":"quotes-module--quoteWrap--_Js6H"};